import { ArrowRightIcon } from 'modules/icons/ArrowRight';

import * as S from './Articles.style';
import * as T from './Articles.types';

export const Articles: React.FC<T.ArticlesCollection> = ({ items }) => {
  return (
    <S.MelhorUso className="section">
      <S.Container>
        <h2>Saiba fazer o melhor uso do que a Olist Vnda oferece</h2>
        <div className="content">
          {items.map((item) => {
            return (
              <div key={item.title} className="card">
                <a href={item.link} target="_blank" rel="noreferrer">
                  <p>{item.subtitle}</p>
                  <p>
                    <strong>{item.title}</strong>
                  </p>
                  <span>
                    Saiba mais
                    <ArrowRightIcon />
                  </span>
                </a>
              </div>
            );
          })}
        </div>
        <S.Link href="http://ajuda.vnda.com.br/pt-BR/" target="_blank" rel="noreferrer">
          outros artigos do Ajuda Vnda
          <ArrowRightIcon />
        </S.Link>
      </S.Container>
    </S.MelhorUso>
  );
};
